import { convertHeicToJpeg, isHeicFile } from "../../utils/heicConversion";

export const prescriptionFileError = (file) => {
  if (!file) return "Choose a prescription document.";
  if (!/\.(pdf|docx|png|jpe?g|jpe|jfif|webp|heic|heif)$/i.test(file.name)) {
    return "Choose a PDF, DOCX, PNG, JPEG, WebP, HEIC or HEIF file.";
  }
  if (!file.size || file.size > 10 * 1024 * 1024) return "Choose a non-empty file up to 10 MB.";
  return "";
};

export const preparePrescriptionFile = async (file) => {
  const error = prescriptionFileError(file);
  if (error) throw new Error(error);
  if (!isHeicFile(file)) return file;

  try {
    const jpeg = await convertHeicToJpeg(file);
    const convertedError = prescriptionFileError(jpeg);
    if (convertedError) throw new Error(convertedError);
    return jpeg;
  } catch (error_) {
    throw new Error(`Unable to convert ${file.name} to JPEG. Choose another image or convert it to JPEG first.`, {
      cause: error_,
    });
  }
};

export const preparePrescriptionFiles = (files) =>
  Promise.all(Array.from(files || []).map(preparePrescriptionFile));
